import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import QueryString from 'qs';
import { generateQueryParams } from 'utils/generateQueryParams';
import { isNumeric } from 'utils/isNumeric';
import { useMe } from './useMe';

export function useFilters(initialValue) {
  const user = useMe();
  const [filters, setFilters] = useState({
    ...initialValue,
    ...(user.tribeId === 3 ? null : user.tribeId),
  });
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    const filtersQuery = QueryString.parse(params.toString());

    delete filtersQuery.page;
    delete filtersQuery.perPage;

    Object.keys(filtersQuery).forEach((key) => {
      const value = filtersQuery[key];

      if (Array.isArray(value)) {
        if (value.every(isNumeric)) {
          filtersQuery[key] = value.map(Number);
        }
      } else if (isNumeric(value)) {
        filtersQuery[key] = Number(value);
      }
    });

    setFilters({
      ...filters,
      ...filtersQuery,
      tribe_id: user.tribeId === 3 ? null : user.tribeId,
    });
  }, []);

  const handleFilters = (newFilters) => {
    const updatedFilters = { ...filters, ...newFilters };

    const cleanFilters = generateQueryParams({
      page: params.get('page'),
      perPage: params.get('perPage'),
      ...updatedFilters,
    });

    const filtersParams = QueryString.stringify(cleanFilters, {
      arrayFormat: 'brackets',
    });

    setFilters(updatedFilters);
    setParams(filtersParams);
  };

  const resetFilters = () => {
    setFilters(initialValue);
  };

  return {
    filters,
    handleFilters,
    resetFilters,
  };
}
